import type { DbProperty } from "@/lib/server-db";

export function slugifyPropertyName(value: string): string {
  return value
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 80) || "alojamiento";
}

export function propertyPublicSlug(property: Pick<DbProperty, "id" | "name" | "slug">): string {
  return property.slug || slugifyPropertyName(property.name) || property.id;
}

export function uniquePropertySlug(
  properties: DbProperty[],
  agencyId: string,
  value: string,
  excludeId?: string,
): string {
  const base = slugifyPropertyName(value);
  let candidate = base;
  let suffix = 2;
  while (properties.some((property) => property.agencyId === agencyId && property.id !== excludeId && property.slug === candidate)) {
    candidate = `${base}-${suffix++}`;
  }
  return candidate;
}

export function publicPropertyPath(agencyId: string, property: Pick<DbProperty, "id" | "name" | "slug">, customDomain = false): string {
  const path = `/propiedad/${propertyPublicSlug(property)}`;
  return customDomain ? path : `/site/${agencyId}${path}`;
}
